module.exports = __webpack_public_path__ + "img/propertylist2.fa70c0f5.png";